import { Component, output } from "@angular/core";
import { EmptystateComponent } from "@ankaadia/ui";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiMilestoneAggregatedViewComponent } from "../../milestones/milestone-aggregated-view/new-ui-milestone-aggregated-view.component";
import { NewUiDashboardCardHeaderComponent } from "../layout/new-ui-dashboard-card-header/new-ui-dashboard-card-header.component";
import { NewUiDashboardCardComponent } from "../layout/new-ui-dashboard-card/new-ui-dashboard-card.component";

@Component({
  selector: "new-ui-dashboard-milestone",
  templateUrl: "./new-ui-dashboard-milestone.component.html",
  imports: [
    NewUiDashboardCardHeaderComponent,
    TranslateDirective,
    NewUiDashboardCardComponent,
    NewUiMilestoneAggregatedViewComponent,
    EmptystateComponent,
  ],
})
export class NewUiDashboardMilestoneComponent {
  protected candidateSum = 0;

  readonly rowCount = output<number>();

  onCandidateSumChange(sum: number): void {
    this.candidateSum = sum;
  }

  onRowCountChange(rowCount: number): void {
    this.rowCount.emit(rowCount);
  }
}
